export default {
	"roads": {
		"mobile": "หมายเลขโทรศัพท์",
		"executionHandle": "ดูการใช้งาน",
		"deliveryExecution": "การดำเนินการจัดส่ง",
		"billPayable": "ใบเรียกเก็บเงินที่ต้องชำระ",
		"routerNoDataRange": "กรุณากรอกหมายเลขการจัดส่งหรือเลือกช่วงเวลาในการสร้าง",
		"importDataCorrection": "นำเข้าข้อมูลการดำเนินการ",
		"exportDataCorrection": "ส่งออกข้อมูลการดำเนินการ",
		"downloadTransportManifest": "ดาวน์โหลดใบกำกับการขนส่ง",
		"backToDocPOD": "กลับไปที่ Documentation & POD",
	},
	"roadsMultiple": {
		"waybillDetails": "รายละเอียดของใบตราส่งสินค้า",
		"actualGoodsQty": "จำนวนสินค้าที่รับจริง",
		"finishTransportQty": "จำนวนใบตราส่งสินค้าที่เสร็จสมบูรณ์",
		"actualTonKm": "ตัน-กิโลเมตรจริง",
		"actualFullLoadRatio": "อัตราการบรรทุกเต็มคันรถจริง",
		"stayPointInformation": "ข้อมูลจุดจอด",
		"roadsmultiple": "ระยะทาง",
		"latestReceiverStation": "สถานที่จัดส่งที่ใกล้ที่สุด",
		"transitTime": "เวลาขนส่ง",
		"senderAddressTips": "อนุญาตให้เลือกที่อยู่ที่ได้ระบุไว้ "
	},
	"roadsSingle": {
		"actualTime": "เวลาตามจริง"
	},
	"roadsCheckStatus": {
		"save": "บันทึก",
		"new": "ใหม่",
		"confirmed": "ยืนยัน",
		"recheck": "ตรวจสอบอีกครั้ง"
	},
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/roads/roads.js